import React from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { blue, red } from "../../../../../utils/colors";
import Backdrop from "../../../../shared/Backdrop";
import { BlurOther } from "../../../../shared/Blur";
import Icon from "../../../../shared/icons/Icon";
import ModalPortal from "../../../../shared/Modal/Portal";
import Button from "../../../../shared/NewForms/Button";
import NewHeadline from "../../../../shared/NewHeadline";

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 20;
    width: 100%;
    height: 100%;
    ${({ theme }) => theme.paddings.containerOuter.left}
    ${({ theme }) => theme.paddings.containerOuter.right}
`;

const ModalContentContainer = styled.div`
    z-index: 23;
    width: 90%;
    height: fit-content;
    background-color: white;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    max-height: 85vh;
    margin: 30px auto 0;
    ${({ theme }) => theme.breakpoints.from.small.css`
        width: 50%;
    `}
    ${({ theme }) => theme.breakpoints.from.large.css`
        margin-top: 150px;
    `}
`;

const ModalHeadlineRow = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 20px 20px 0;
`;

const ModalBottomRow = styled.div`
    ${({ theme }) => theme.paddings.containerOuter.left}
    ${({ theme }) => theme.paddings.containerOuter.right}

  margin: 20px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    row-gap: 20px;
    ${({ theme }) => theme.breakpoints.from.small.css`
            flex-direction: row;
            column-gap: 10px;
            justify-content: space-around;
        `}
    ${({ theme }) => theme.breakpoints.from.large.css`
            padding: 0 176px;
        `}
`;

interface iModal {
    children?: any;
    isActive: boolean | null;
    handleClose: any;
    handleSubmit?: any;
    handleModal?: any;
    headline?: string;
    closeButton?: string;
    submitButton?: string;
    actionRow?: boolean;
    disableYOverflow?: boolean;
}

const Modal = ({
    children,
    isActive = null,
    handleClose,
    handleSubmit,
    handleModal,
    headline = "Adresse ändern",
    closeButton = "Abbrechen",
    submitButton = "Übernehmen",
    actionRow = true,
    disableYOverflow = false,
}: iModal) => {
    const open = !!isActive;

    const ModalContent = styled(ModalContentContainer)`
        overflow-y: ${disableYOverflow ? "none" : "auto"};
    `;

    return (
        <ModalPortal>
            {open && <BlurOther blur={["Page"]} />}

            <Backdrop {...{ open }} onClick={handleModal} className="backdrop">
                <ModalContainer className="backdrop">
                    <ModalContent>
                        <ModalHeadlineRow>
                            <NewHeadline
                                lookLike={1}
                                css={css`
                                    line-height: 2.2rem;
                                `}
                            >
                                {headline}
                            </NewHeadline>
                            <Icon
                                iconName="close"
                                style={css`
                                    cursor: pointer;
                                `}
                                handleClick={handleClose}
                                size="18px"
                                sMedium="20"
                                sExtraSmall="25px"
                                hoverColor={red}
                                color={blue}
                            />
                        </ModalHeadlineRow>
                        {children}
                        {actionRow && (
                            <ModalBottomRow>
                                <Button
                                    color="grey"
                                    onClick={handleClose}
                                    fontSize="0.8em"
                                >
                                    {closeButton}
                                </Button>

                                <Button
                                    color="red"
                                    onClick={handleSubmit}
                                    fontSize="0.8em"
                                >
                                    {submitButton}
                                </Button>
                            </ModalBottomRow>
                        )}
                    </ModalContent>
                </ModalContainer>
            </Backdrop>
        </ModalPortal>
    );
};

export default Modal;
